export default "__VITE_ASSET__CxPrt7w3__"